module.exports = __webpack_public_path__ + "static/media/close.83a119a6.svg";